export default {
    ourPortfolio: 'ดูผลงานของเรา',
    companyDescription: 'เรารับแก้ปัญหาทางธุรกิจของท่านด้วยซอฟท์แวร์',
    customSoftware: 'เรารับทำซอฟท์แวร์ตามความต้องการของธุรกิจของท่าน ไม่ว่าจะเป็นซอฟท์แวร์ที่ใช้สำหรับ Desktop PC รวมถึง Web Application เราก็ทำได้! ท่านกำลังมีปัญหาอะไรอยู่หรือเปล่า ลองมาเล่าให้เราฟัง!',
    website: 'รับทำเว็บไซต์ทุกประเภท ไม่ว่าจะเป็น เว็บไซต์สำหรับองค์กรทั่วไป หรือ เว็บไซต์สำหรับใช้งานเฉพาะทาง เราก็ทำได้!',
    dataScraping: 'อยากรวบรวมข้อมูลต่างๆ เพื่อช่วยในการตัดสินใจสำหรับธุรกิจของคุณ ทักมาปรึกษาเราได้เลย! เรารับเก็บข้อมูลจากแหล่งออนไลน์ต่างๆ ทำการประมวลผลและนำเสนอในรูปแบบที่ท่านต้องการ',
    contact: 'ติดต่อ'
}
